import { connect } from 'react-redux';

import {
  customerSiteMockUpAction,
  getAllRates,
  getAvailableQualForDailyQuiz,
  getCustomerSiteMockUpAction,
  getLastCouponUserAction,
  setAvailableQualForDailyQuiz,
  setCustomerMessage,
  setFlashSectionChoose,
} from '../../actions/accountSettingsAction';
import {
  setUserSettingQualForDailyQuizMessage,
  updateUserSettingQualForDailyQuiz,
} from '../../actions/userActions';
import {
  getAvailableQualForDailyQuizSelector,
  getCustomerMessage,
  getCustomerSiteMockUp,
  getFlashSectionChoose,
} from '../../components/AccountSettings/AccountSettingsSelectors';
import AccountSettings from '../../components/AccountSettings/AccountSettingsView';
import { getIsLoadingCustomerSite } from '../../components/AccountSettings/NotificationPreferences/NotificationPreferencesSelectors';
import {
  getLoadingQualForDailyQuizSelector,
  getUser,
  getUserSettingQualForDailyQuizMessage,
} from '../../components/User/userSelectors';
import { verifyLoggedUser } from '../../utils/verifyUserLogged';

const mapStateToProps = (state) => ({
  user: getUser(state),
  customerMessage: getCustomerMessage(state),
  customerSiteMockUp: getCustomerSiteMockUp(state),
  loadingCustomerSite: getIsLoadingCustomerSite(state),
  availableQualForDailyQuiz: getAvailableQualForDailyQuizSelector(state),
  userSettingQualForDailyQuizMessage:
    getUserSettingQualForDailyQuizMessage(state),
  loadingUpdateUserSettingQualForDailyQuiz:
    getLoadingQualForDailyQuizSelector(state),
  flashChoose: getFlashSectionChoose(state),
});

const mapDispatchToProps = (dispatch) => ({
  getAllRates: () => dispatch(getAllRates()),
  verifyLoggedUser: () => verifyLoggedUser(),
  setCustomerSiteMockUp: (customer) =>
    dispatch(customerSiteMockUpAction(customer)),
  setCustomerMessage: (message) => dispatch(setCustomerMessage(message)),
  getCustomerSiteMockUp: (userId) =>
    dispatch(getCustomerSiteMockUpAction(userId)),
  getLastCouponUserAction: () => dispatch(getLastCouponUserAction()),

  getAvailableQualForDailyQuiz: () => dispatch(getAvailableQualForDailyQuiz()),

  setAvailableQualForDailyQuiz: (quals) =>
    dispatch(setAvailableQualForDailyQuiz(quals)),

  updateUserSettingQualForDailyQuiz: (qual) =>
    dispatch(updateUserSettingQualForDailyQuiz(qual)),

  setUserSettingQualForDailyQuizMessage: (message) =>
    dispatch(setUserSettingQualForDailyQuizMessage(message)),

  setFlashSectionChoose: (value) => dispatch(setFlashSectionChoose(value)),
});

const AccountSettingsContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AccountSettings);

export default AccountSettingsContainer;
